var pym = require("./lib/pym");
var pymChild = null;
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

// check if this user has set "prefers reduced motion" in their browser
// https://since1979.dev/respecting-prefers-reduced-motion-with-javascript-and-react/
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

var onResize = function() {
  pymChild.sendHeight();
}

// initial setup
pym.then(child => {
  pymChild = child;

  var items = document.querySelectorAll(".sector .item");

  if (!reducedMotion.matches) {
    var observer = new IntersectionObserver(function(entries) {
  	if(entries[0].isIntersecting) {
  		// console.log('Element has just become visible in screen');
      items.forEach((item, i) => {
        setTimeout(function(){ item.classList.add('active'); }, i == 0 ? 500 : (i+1) * 2000);
        item.classList.remove("inactive");
      });
    }
    pymChild.sendHeight();
    }, { threshold: [0.5] });

      items.forEach((item, i) => {
        item.classList.add("inactive");
      });

    observer.observe(document.querySelector(".text-wrapper"));

    } else if (reducedMotion.matches) {
      items.forEach((item, i) => {
        item.classList.add("active");
      })
    }

  pymChild.sendHeight();
  window.addEventListener("resize", onResize);
});
